import { Link } from 'react-router-dom';

import type { EnrichedModuleProgress } from '@/hooks/use-training-progress';

import { Badge } from '@/components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatDate, formatPercentage } from '@/lib/format';


interface ModuleCompletionTableProps {
  modules: EnrichedModuleProgress[];
}

export function ModuleCompletionTable({ modules }: ModuleCompletionTableProps) {
  const sorted = [...modules].sort((a, b) => a.order_index - b.order_index);

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-12">#</TableHead>
          <TableHead>Module</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Date</TableHead>
          <TableHead>Score</TableHead>
          <TableHead className="w-20"></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {sorted.map((m) => (
          <TableRow key={m.module_id}>
            <TableCell className="font-medium">{m.order_index + 1}</TableCell>
            <TableCell>{m.title}</TableCell>
            <TableCell>
              <Badge
                variant={
                  m.status === 'completed'
                    ? 'success'
                    : m.status === 'in_progress'
                      ? 'outline'
                      : 'secondary'
                }
              >
                {m.status === 'completed'
                  ? 'Completed'
                  : m.status === 'in_progress'
                    ? 'In Progress'
                    : 'Not Started'}
              </Badge>
            </TableCell>
            <TableCell>
              {m.completed_at ? formatDate(m.completed_at) : '—'}
            </TableCell>
            <TableCell>
              {m.score_percentage != null ? formatPercentage(m.score_percentage) : '—'}
            </TableCell>
            <TableCell>
              {m.status === 'completed' ? (
                <Link
                  to={`/training/modules/${m.module_id}`}
                  className="text-sm text-primary hover:underline"
                >
                  Review
                </Link>
              ) : m.status === 'in_progress' ? (
                <Link
                  to={`/training/modules/${m.module_id}`}
                  className="text-sm text-primary hover:underline"
                >
                  Continue
                </Link>
              ) : null}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
